import React, { useEffect, useState } from "react";

import { Badge, Space } from "antd";
import { BsCircleFill } from "react-icons/bs";
import { GrCircleAlert } from "react-icons/gr";
import moment from "moment";
import { Calendar } from "antd";
import dayjs from "dayjs";
import { CalendarMode } from "antd/es/calendar/generateCalendar";
import "../App.css";
import { Button, Col, Row, Select, theme, Popover } from "antd";
import "dayjs/locale/el";
// import dayLocaleData from "dayjs/plugin/localeData";
import NameDay from "./nameDays";
dayjs.locale("el");
var updateLocale = require("dayjs/plugin/updateLocale");
dayjs.extend(updateLocale);
let monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const TranslatedText = ({ greekText, englishText }) => {
  const [translatedText, setTranslatedText] = useState("");

  useEffect(() => {
    const lang = document.documentElement.lang;
    if (lang === "el") {
      setTranslatedText(greekText);
      dayjs.updateLocale("en", {
        weekdays: ["KY", "ΔE", "ΤΡ", "ΤΕ", "ΠΕ", "ΠΑ", "ΣΑ"],
      });
      monthNames = [
        "Ιανουάριος",
        "Φεβρούαριος",
        "Μάρτιος",
        "Απρίλιος",
        "Μάιος",
        "Ιούνιος",
        "Ιούλιος",
        "Αύγουστος",
        "Σεπτέμβριος",
        "Οκτώβριος",
        "Νοέμβριος",
        "Δεκέμβριος",
      ];
    } else {
      setTranslatedText(englishText);
    }
  }, [greekText, englishText]);

  return <span dangerouslySetInnerHTML={{ __html: translatedText }} />;
};

const content = (
  <div>
    <p>
      <TranslatedText
        greekText="<span lang='el'><ul><li>Στις Ιερές Μονές του Αγίου Όρους, στις ημέρες νηστείας –αλάδωτο ξηροφαγία- εκτός της Τετάρτης και της Παρασκευής, περιλαμβάνεται και η Δευτέρα- προς δόξαν των αγγέλων-, ενώ ασιτία –πλήρης αποχή από τροφή- τηρείται από τους Μοναχούς το πρώτο τριήμερο της Καθαράς Εβδομάδας.</li>
        <li>Στο Άγιον Όρος οι Μοναχοί απέχουν από την κατανάλωση κρέατος καθ΄ όλην τη διάρκεια του έτους. </li>
       <li> Στις Ιερές Μονές του Αγίου Όρους η κατάλυση οίνου και ελαίου, σε περιόδους νηστείας, επιτρέπεται και στις εορτές Αγίων Κτητόρων, Αγίων του Αγιολογίου της Μονής, Αγίων που η Μονή έχει λείψανα και τους πανηγυρίζει, σε αναμνήσεις Θαυμάτων.</li></ul>
        </span>"
        englishText="<span lang='en'> <ul><li>Στις Ιερές Μονές του Αγίου Όρους, στις ημέρες νηστείας –αλάδωτο ξηροφαγία- εκτός της Τετάρτης και της Παρασκευής, περιλαμβάνεται και η Δευτέρα- προς δόξαν των αγγέλων-, ενώ ασιτία –πλήρης αποχή από τροφή- τηρείται από τους Μοναχούς το πρώτο τριήμερο της Καθαράς Εβδομάδας.</li>
        <li>Στο Άγιον Όρος οι Μοναχοί απέχουν από την κατανάλωση κρέατος καθ΄ όλην τη διάρκεια του έτους. </li>
       <li> Στις Ιερές Μονές του Αγίου Όρους η κατάλυση οίνου και ελαίου, σε περιόδους νηστείας, επιτρέπεται και στις εορτές Αγίων Κτητόρων, Αγίων του Αγιολογίου της Μονής, Αγίων που η Μονή έχει λείψανα και τους πανηγυρίζει, σε αναμνήσεις Θαυμάτων.</li></ul></span>"
      />
    </p>
  </div>
);

var events = [];
const tagChoices = [
  {
    tag: "fasting",
    color: "#F96A3D",
  },
  {
    tag: "everything",
    color: "#2B0668",
  },
  {
    tag: "wine",
    color: "#EBE318",
  },
  {
    tag: "cheese",
    color: "#CD44FD",
  },
  {
    tag: "fish",
    color: "#67BFFF",
  },
];

const DarkEventCalendar = () => {
  const [selectedMonth, setSelectedMonth] = useState("January");
  const handleMonthButtonClick = (month) => {
    setSelectedMonth(month);
  };
  const [selectedEvents, setSelectedEvents] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
  );
  const handleClickScroll = () => {
    const element = document.getElementById("fit");
    if (element) {
      //

      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const selectEvent = (day) => {
    setSelectedDate(day);
    var filterdEvents = events.filter((e) => e.date === day);

    setSelectedEvents(filterdEvents);
  };

  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());

  const { token } = theme.useToken();
  const onPanelChange = (value, mode) => {};
  const wrapperStyle = {
    width: "40%",
    "border-radius": "8px",
    padding: "16px 32px",
    display: "flex",
    "flex-direction": "column",
    "align-items": "flex-start",
  };
  const [data, setData] = useState([]);
  const dateArray = selectedDate;
  let yearT;
  let monthT;
  if (dateArray.includes("/")) {
    const FormattedDate = dateArray.split("/");
    yearT = FormattedDate[2];
    monthT = FormattedDate[0];
  } else {
    const FormattedDate = dateArray.split("-");
    yearT = FormattedDate[0];
    monthT = FormattedDate[1];
  }
  console.log(dateArray);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://calendarback.epantokrator.gr/api/period?month=${monthT}&year=${yearT}`
        );
        const data = await response.json();
        setData(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [monthT, yearT]);
  console.log("hi");
  console.log(data);
  const dataEverything = data
    .filter((item) => item.tag)
    .flatMap((item) => [{ tag: item.tag, dates: item.dates }]);
  console.log(dataEverything);
  console.log(dataEverything);
  const dateCellRender = (value) => {
    const listData = dataEverything.filter((p) => {
      for (let i = 0; i < p.dates.length; i++) {
        if (dayjs(p.dates[i]).isSame(value, "day")) {
          return true;
        }
      }
      return false;
    });
    console.log(listData);
    const colored = listData.map((item) => {
      const matchedTag = tagChoices.find((tc) => tc.tag === item.tag);
      if (matchedTag) {
        return { ...item, color: matchedTag.color };
      }

      return item;
    });
    console.log(colored);
    return (
      <div className="events" onClick={handleClickScroll}>
        {colored.map((item) => (
          <BsCircleFill
            fontSize={"0.8em"}
            style={{
              "border-radius": "4px",
              "text-align": "center",

              gap: "4px",
            }}
            color={`${item.color}`}
          />
        ))}
      </div>
    );
  };
  const FormattedDate = ({ selectedDate }) => {
    let date = new Date(selectedDate);
    return (
      <p>
        <TranslatedText
          greekText={`<span lang="el">${
            date.toLocaleString("el-GR", {
              day: "numeric",
              month: "long",
            }) +
            ", " +
            date.getFullYear()
          }</span>`}
          englishText={`<span lang="el">${date.toLocaleString("en", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}</span>`}
        />
      </p>
    );
  };
  return (
    <div style={{ display: "flex" }}>
      <div style={wrapperStyle}>
        <Calendar
          eventType="Fill"
          onSelect={(e) => selectEvent(e.format("YYYY-MM-DD"))}
          dateCellRender={dateCellRender}
          holidays={["2023-01-23"]}
          events={events}
          headerRender={({ value, type, onChange, onTypeChange }) => {
            const monthOptions = [];
            let current = value.clone();
            const localeData = value.localeData();
            const months = [];
            for (let i = 0; i < 12; i++) {
              current = current.month(i);
              months.push(localeData.monthsShort(current));
            }
            for (let i = 0; i < 12; i++) {
              monthOptions.push(
                <Select.Option
                  key={i}
                  value={i}
                  className="month-item"
                  style={{ background: "#f9f5ff" }}
                >
                  {monthNames[i]}
                </Select.Option>
              );
            }

            console.log(monthOptions);
            const year = value.year();
            const month = value.month();

            const options = [];
            for (let i = 2023; i < 2023 + 10; i += 1) {
              options.push(
                <Select.Option
                  key={i}
                  value={i}
                  className="year-item"
                  style={{ background: "#f9f5ff" }}
                >
                  {i}
                </Select.Option>
              );
            }

            return (
              <div
                style={{
                  padding: 8,
                  backgroundColor: "#fffef7",
                }}
              >
                {/* <Typography.Title level={4}>Ημερολόγιο</Typography.Title> */}

                <Row
                  gutter={8}
                  style={{
                    display: "flex",
                    "justify-content": "flex-end",
                    "flex-direction": "row-reverse",
                  }}
                >
                  <Col style={{ "margin-left": "auto" }}>
                    <Button
                      className="my-button-for-today"
                      style={{
                        background: "#F2F2F2",
                        borderColor: "transparent",
                      }}
                      size="medium"
                      onClick={() => {
                        onChange(
                          value
                            .clone()
                            .year(moment().year())
                            .month(moment().month())
                            .date(moment().date())
                        );
                      }}
                    >
                      <TranslatedText
                        greekText="<span lang='el'>Σήμερα</span>"
                        englishText="<span lang='en'>Today</span>"
                      />
                    </Button>
                  </Col>
                  <Col>
                    <Select
                      listHeight={3000}
                      size="medium"
                      dropdownMatchSelectWidth={false}
                      className="my-year-select"
                      style={{ borderColor: "transparent" }}
                      value={year}
                      onChange={(newYear) => {
                        const now = value.clone().year(newYear);
                        onChange(now);
                      }}
                    >
                      {options}
                    </Select>
                  </Col>
                  <Col>
                    <Select
                      listHeight={3000}
                      size="medium"
                      dropdownMatchSelectWidth={false}
                      value={month}
                      onChange={(newMonth) => {
                        const now = value.clone().month(newMonth);
                        onChange(now);
                      }}
                    >
                      {monthOptions}
                    </Select>
                  </Col>
                </Row>
              </div>
            );
          }}
          onPanelChange={onPanelChange}
        />
        <div
          style={{
            background: "#fffef7",
            marginRight: "10px",
            display: "inline-flex",
            "padding-top": "10px",
            "flex-direction": "column",
          }}
        >
          <p
            style={{
              "border-bottom": "1px solid #E6E6E6",
              "margin-top": "20px",
              "font-style": "normal",
              "font-weight": "500",
              "font-size": "14px",
              "line-height": "17px",
              fontFamily: "Helvetica Neue",
              marginBottom: "13.5px",
            }}
          >
            <TranslatedText
              greekText={`<span lang='el'>ΠΕΡΙΟΔΟΙ ΝΗΣΤΕΙΑΣ ΚΑΙ ΚΑΤΑΛΥΣΗΣ ΤΡΟΦΩΝ</span>`}
              englishText={`<span lang='en'>FASTING PERIODS AND ALLOWANCE OF FOOD</span>`}
            />
          </p>
          <Space
            size={[8, 16]}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "normal",
            }}
            wrap
          >
            <div>
              <BsCircleFill color="#F96A3D" fontSize={"0.8em"} />
              <TranslatedText
                greekText={`<span lang='el'  style='padding-left: 7px;'>Αλάδωτο (Ξηροφαγία)</span>`}
                englishText="<span lang='en' style='padding-left: 7px;'>Fasting</span>"
              />
            </div>
            <div>
              {" "}
              <BsCircleFill
                color="#EBE318"
                fontSize={"0.8em"}
                marginRight={"10px"}
              />
              <TranslatedText
                greekText={
                  "<span lang='el' style='padding-left: 7px;font-family: 'Helvetica Neue';font-style: normal;font-weight: 400; font-size: 18px;line-height: 21px;'>Κατάλυση οίνου και ελαίου</span>"
                }
                englishText="<span lang='en' style='padding-left: 7px;font-family: 'Helvetica Neue';font-style: normal;font-weight: 400; font-size: 18px;line-height: 21px;'>Wine and Olive Oil are allowed</span>"
              />
            </div>
            <div>
              {" "}
              <BsCircleFill color="#CD44FD" fontSize={"0.8em"} />
              <TranslatedText
                greekText={
                  "<span lang='el' style='padding-left: 7px;font-family: 'Helvetica Neue';font-style: normal;font-weight: 400; font-size: 18px;line-height: 21px;'>Κατάλυση αυγών και τυροκομικών (τυρινή)</span>"
                }
                englishText="<span lang='en' style='padding-left: 7px;font-family: 'Helvetica Neue';font-style: normal;font-weight: 400; font-size: 18px;line-height: 21px;'>Eggs and Dairy are allowed</span>"
              />
            </div>
            <div>
              <BsCircleFill color="#67BFFF" fontSize={"0.8em"} />

              <TranslatedText
                greekText={
                  "<span lang='el' style='padding-left: 7px;font-family: 'Helvetica Neue';font-style: normal;font-weight: 400; font-size: 18px;line-height: 21px;'>Κατάλυση ιχθύος</span>"
                }
                englishText="<span lang='en' style='padding-left: 7px;font-family: 'Helvetica Neue';font-style: normal;font-weight: 400; font-size: 18px;line-height: 21px;'>Fish are allowed</span>"
              />
            </div>
            <div>
              {" "}
              <BsCircleFill color="#2B0668" fontSize={"0.8em"} />
              <TranslatedText
                greekText={
                  "<span lang='el' style='padding-left: 7px;font-family: 'Helvetica Neue';font-style: normal;font-weight: 400; font-size: 18px;line-height: 21px;'>Κατάλυση εις πάντα</span>"
                }
                englishText="<span lang='en' style='padding-left: 7px;font-family: 'Helvetica Neue';font-style: normal;font-weight: 400; font-size: 18px;line-height: 21px;'>Every food is allowed</span>"
              />
            </div>
          </Space>
        </div>
      </div>

      <div className="Right-side" id="fit">
        <div
          style={{
            flex: "none",
            order: 1,
            "align-self": "stretch",
            "flex-grow": 0,
          }}
        >
          <div
            style={{
              "font-family": "Helvetica Neue",
              "font-style": "normal",
              "font-weight": "500",
              "font-size": "24px",
              "line-height": "29px",
            }}
          >
            {" "}
            {FormattedDate({ selectedDate })}
          </div>

          {selectedDate && <NameDay date={selectedDate} />}
          <div style={{ display: "flex", "flex-direction": "row-reverse" }}>
            <Popover content={content} trigger="hover" placement="bottomRight">
              <Button
                style={{
                  "border-color": "transparent",
                }}
              >
                <GrCircleAlert style={{ marginRight: "5px" }} />
                <TranslatedText
                  greekText={`<span lang='el'>Υποσημειώσεις</span>`}
                  englishText="<span lang='en'>Notes</span>"
                />
              </Button>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DarkEventCalendar;
